/** Max characters for public news search queries (header + /search page). */
export const NEWS_SEARCH_MAX_LENGTH = 100

/** Trim and cap search text for UI, URL, and API. */
export function normalizeNewsSearchQuery(value) {
	return String(value ?? '').trim().slice(0, NEWS_SEARCH_MAX_LENGTH)
}
